import { render, staticRenderFns } from "./ServiceCreation.vue?vue&type=template&id=5dc2458c&scoped=true"
import script from "./ServiceCreation.vue?vue&type=script&lang=ts"
export * from "./ServiceCreation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc2458c",
  null
  
)

export default component.exports